exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-req{color:red}.color-txt{color:#f96868}.space{margin-top:100px}", ""]);

// exports
